<input
  #input
  type="datetime-local"
  class="datetime-input-element"
  [value]="localValue"
  (change)="onValueChange($event)"
  (focusin)="onFocusIn()"
  (focusout)="onFocusOut($event)"
/>
